import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {Item} from '@/components/core';
import Pager from '../_common/pager';
import productData from '../_data/index'



const partnersData = [
  {
    title: '核心企业',
    type: '0',
    child: [1,2,3,4,5,6,7,8,9,10],
    img: '/images/index/partnership.png'
  },
  {
    title: '银行',
    type: '1',
    child: [1,2,3,4,5,6,7,8,9,10],
    img: '/images/index/core.png'
  }
]
// const PagesBody = props => {
//   return (
//     <div className="pages-container index">
//       <div className="pages-part1">
//         {/* <img className="item-pic" src="/images/index/case-bg.jpg"/>
//         <div className="item-wrap"> */}
//           <div className="wid1200">
//             <div className="item-header">
//               <div className="pages-title mb-primary">产融结合解决方案</div>
//               <div className="item-desc mb-default">助力高效链接产业生态、拓展普惠金融场景</div>
//             </div>
//             <div className="item-body">
//               <p>明心数智通过自身多年积累的数据中台共信化搭建能力、产业信用数字化评估能力、银企互联线上化操作能力和贷后管理可视化监测<br/>能力等服务于金融机构，助力其高效链接产业生态、扩展普惠金融场景，实时监测经营状况，有效降低信贷风险。 </p>
//               <img className="item-pic" src="/images/index/case-bg.png"/>
//             </div>
//           </div>
//         {/* </div> */}
//       </div>

//       <div className="pages-part2">
//         <div className="wid1200">
//           <div className="item-header">
//             <div className="pages-title mb-primary">产业信用评估解决方案</div>
//             <div className="item-desc mb-default">面向各行业的解决方案，帮助客户轻松快速进行智能决策</div>
//           </div>
//           <div className="item-body">
//             <p>明心数智基于云计算、AI算法、隐私计算和区块链等领先智能技术，通过丰富的物联网终端和CMP-产融管理运营平台，针对产业生<br/>产、贸易、物流、仓储4大场景，搭建产业信用数字化评估能力平台，为各产业输出综合的数字化评估解决方案，助力产业合作伙伴<br/>更好进行账期管理运营，有效降低账期风险。</p>
//             <div className="item-list">
//               <div className="item">
//                 <div className="item-img"><img src="/images/index/pic1.png"/></div>
//                 <div className="item-title">生产</div>
//               </div>
//               <div className="item">
//                 <div className="item-img"><img src="/images/index/pic2.png"/></div>
//                 <div className="item-title">物流</div>
//               </div>
//               <div className="item">
//                 <div className="item-img"><img src="/images/index/pic3.png"/></div>
//                 <div className="item-title">仓储</div>
//               </div>
//               <div className="item">
//                 <div className="item-img"><img src="/images/index/pic4.png"/></div>
//                 <div className="item-title">贸易</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="pages-part3">
//         {/* <img clss="item-pic" src="/images/index/product-bg.png" />
//         <div clasas="item-wrap"> */}
//           <div className="wid1200">
//             <div className="item-header">
//               <div className="pages-title mb-default">产品中心</div>
//             </div>
//             <div className="item-list">
//               {
//                 productData.map((item, idx) => {
//                   idx = idx + 1
//                   return (
//                     <div className="item" key={'product-'+idx}>
//                       <a href={"/product?"+item.type}>
//                         <i className={"index-icon-" + idx}></i>
//                         <h4 className="item-title mb8">{item.title}</h4>
//                         <h4 className="item-title mb-primary">{item.subtitle}</h4>
//                         <p className="item-desc">{item.desc}</p>
//                       </a>
//                     </div>
//                   )
//                 })
//               }
//             </div>
//           </div>
//        {/* </div> */}
//       </div>
      
//       <div className="pages-part4">
//         <div className="wid1200">
//           <div className="item-header">
//             <div className="pages-title mb-default">合作伙伴</div>
//           </div>
//           {
//             partnersData.map((item, ii) => {
//               return (
//                 <div key={ii}>
//                   <div className="pages-middle-title mb-default" key={'partners-'+ii}><p className="item-title">{item.title}</p></div>
//                   <div className="mb-minor">
//                     <div className="item-ul">
//                       {
//                         item.child.map((it, yy) => {
//                           yy = yy + 1
//                           const name = item.type === '0' ? 'p'+yy : 'b'+yy
//                           return <div className="item" key={'partners-child-'+yy}><img src={"/images/index/"+name+".png"}/></div>
//                         })
//                       }
//                     </div>
//                   </div>
//                 </div>
//               )
//             })
//           }
//           <p className="color-info ss-center">更多合作伙伴…</p>
//         </div>
//       </div>
//     </div>
//   )
// }


const PagesBody2 = props => {
  return (
    <div className="pages-container index">
      <div className="pages-part5">
        <img src="/images/index/001.jpg"/>
        <img src="/images/index/002.jpg"/>
        <div className='part5-title' style={{fontSize:'30px'}}>一句指令AI助手接力交付<br/>云服务/一体机多形态部署</div>
        <img src="/images/index/003.jpg"/>
        <div className='part5-title'>为跨境企业提供一支AI智能助手团队，通过更高效、可管控、可审计的Agent工作流，<br/>明思MYNGX将复杂的跨境服务从过去的数周，缩短到分钟级完成。<br/>明思MYNGX AI助手让每一件中国好货高效抵达全球。</div>
        <img src="/images/index/004.jpg"/>
        <img src="/images/index/005.jpg"/>
        <div className='part5-title' style={{fontSize:'30px'}}>软件研发AI生成<br/>人工决策、人机协同</div>
        <div className='part5-title'>一套基于“人工智能+软件工程”理念打造的新一代软件研发平台，<br/>通过AI驱动的软件研发自动化、自进化优化机制和创新工程实践的沉淀，<br/>实现软件研发从“人工编码”向“AI生成、人工决策、人机协同”的新模式转变。</div>
        <img src="/images/index/006.jpg"/>
        <div className='part5-title' style={{marginTop:'60px'}}>明心数智致力于打造跨境服务AIOS，以“数据+AI”为基础，打造行业首个全链路智能服务体系。<br/>明心数智自研跨境垂域AI大模型，深度融合跨境垂域KNOW-HOW，打通海关、税局、物流、跨境电商平台等多维数据，提供跨境出海一站式智能服务。</div>
        <img src="/images/index/1-1.png"/>
        <img src="/images/index/1-3.png"/>
        <div className='part5-title'>明心数智基于自研的跨境服务出海AI大模型“小明同学”，针对行业核心痛点，推出系列AI Agent，<br/>构建了覆盖跨境全链路的智能服务体系，全面提升企业财税合规、供应链、仓储物流与产品营销等能力。</div>
        <img src="/images/index/1-2.png"/>
      </div>
        
      <div className="pages-part4">
        <div className="wid1200">
          <img style={{margin:'0 auto'}} alt='logo' src="/images/logo-1.png" />
          <div className="item-header">
            <div className="pages-title mb-default">合作伙伴</div>
          </div>
          {
            partnersData.map((item, ii) => {
              return (
                <div key={ii}>
                  <div className="pages-middle-title mb-default" key={'partners-'+ii}><p className="item-title">{item.title}</p></div>
                  <div className="mb-minor">
                  <img style={{margin:'0 auto',width:'100%'}} alt={item.title} src={item.img} />
                    {/* <div className="item-ul">
                      {
                        item.child.map((it, yy) => {
                          yy = yy + 1
                          const name = item.type === '0' ? 'p'+yy : 'b'+yy
                          return <div className="item" key={'partners-child-'+yy}><img src={"/images/index/"+name+".png"}/></div>
                        })
                      }
                    </div> */}
                  </div>
                </div>
              )
            })
          }
          <p className="color-info ss-center">更多合作伙伴…</p>
        </div>
      </div>
    </div>
  )
}

const cfg = {
  // banner: {
  //   data: [
  //     {
  //       img: '/images/index/banner.jpg',
  //       content: {
  //         title: '产业经营评估及数字化服务平台',
  //         desc: '打造产业信用数字化评估能力平台，提升产融结合效率，助力产业数字化升级',
  //         buttonText: '关于明心, CMP介绍',
  //         buttonType: 'modal,modal'
  //       }
  //     }
  //   ]
  // },
  // body: <PagesBody />
  body: <PagesBody2 />
}
const App = () => (
  <Pager {...cfg} />
);

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)